// All needed imports
import { SelectModel } from '../../core/models/select.model';
import { CalendarBaseModel } from '../../core/models/calendar-base.model';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { RadioCardListModel } from 'src/app/core/models/radio-card-list.model';
import { RadioCardModel } from '../../core/models/radio-card.model';
import { CheckboxModel } from '../../core//models/checkbox.model';
import { InputModel } from '../../core//models/input.model';
import { Numbers } from 'src/app/utils/constants';
import { setCheckboxModel, setInputModel, setRadioCardModel, setRadioPointModel, setSelectModel,
  setSelectOptions, setSelectValue } from 'src/app/utils/labels.utils';
import { commonLegalInsuredData, setDateLegalFormConfig } from 'src/app/utils/form-utils-extended';
import { commonLegalDomiciliation, guaranteeSelectionLegal } from 'src/app/utils/form-utils.extended-extended';

/**
 * Export the obj to be used in the angular components app
 */
export const FORM_CONFIG: any = {
  currentStep: new BehaviorSubject(1),
  // Increment the step
  stepIncrement(): void {
    this.currentStep.pipe(
      take(1)
    ).subscribe(num => {
      let numero: number = num;
      if ( num !== Numbers.number4 ) {
        ++num;
        numero = num;
      }
      this.currentStep.next(numero);
    });
  },
  // Decrement the current step
  stepDecrement(): void {
    this.currentStep.pipe(
      take(1)
    ).subscribe(num => {
      let numero = 1;
      if ( num > 1 ) {
        --num;
        numero = num;
      }
      this.currentStep.next(numero);
    });
  },
  // Date attribute
  date: new CalendarBaseModel(setDateLegalFormConfig('ownerLegalAsistance')),
  // MonthlyRent attribute
  monthlyRent: new InputModel(setInputModel(['ownerLegalAsistance', 'monthlyRent'], 'legal.monthlyRent',
  { value: '', requiredText: 'form1.default-error', onlynumberError: 'legal.monthlyRent.onlynum-1-error'}, true)),
  // codePromotional attribute
  codePromotional: new InputModel(setInputModel(['ownerLegalAsistance', 'codePromotional'], 'form1.promotional', {value: ''})),
  // inssuranceType attribute
  // Arrendador vivienda type
  insuranceType: new RadioCardListModel({
    linkFormPath: ['ownerLegalAsistance', 'insuranceType'],
    radioCardList: [
      new RadioCardModel(setRadioCardModel(Numbers.number0, 'legal.rent.coverage0')),
      new RadioCardModel(setRadioCardModel(Numbers.number1, 'legal.rent.coverage1'))
    ]
  }),
  // insuredData attribute
  insuredData: {
    // type owner
    typeOwner: {
      linkFormPath: ['ownerLegalAsistance', 'insuredData', 'typeOwner'],
      value: 'Particular'
    },
    // particular
    particular: {
      // name
      name: new InputModel( setInputModel(['ownerLegalAsistance', 'insuredData', 'particular', 'name'], 'form1.particular.name',
      { requiredText: 'form1.particular.name.error'}, true))
    },
    // bussines
    bussines: {
      // company Sector
      companySector: new SelectModel(
        setSelectModel(['ownerLegalAsistance', 'insuredData', 'bussines', 'companySector'],
        setSelectValue('form1.bussines.company-selector', 'form1.bussines.company-selector.error'),
        setSelectOptions('', '', [{ name: 'Construccion', id: Numbers.number0 }, { name: 'Hostelería',
        id: Numbers.number1 }, { name: 'Turismo', id: Numbers.number2 }])
      )),
      // direction
      direction: new InputModel({
        linkFormPath: ['ownerLegalAsistance', 'insuredData', 'bussines', 'direction'],
        label: 'form1.bussines.direction-selector',
        required: true,
        requiredText: 'form1.bussines.direction-selector.error'
      })
    },
    // document type
    documentType: new SelectModel(
      setSelectModel(['ownerLegalAsistance', 'insuredData', 'documentType'],
      setSelectValue('form1.bussines.document-selector', 'legal.bussines.document-selector.error'),
      setSelectOptions('', '', [{ name: 'NIF', id: Numbers.number1 },
      { name: 'NIE', id: Numbers.number3 }])
    )),
    // Province
    province: new InputModel( setInputModel(['ownerLegalAsistance', 'insuredData', 'province'], 'form1.province',
    { requiredText: 'form1.default-error'}, true)),
    ...commonLegalInsuredData('ownerLegalAsistance')
  },
  // insuredListData
  insuredListData: {
    linkFormPath: ['ownerLegalAsistance', 'insuredListData'],
    owner: {
      documentType: new SelectModel(
        setSelectModel(['ownerLegalAsistance', 'insuredListData', 'owner', 'documentType'],
        setSelectValue('form1.listdata.document-type', 'form1.default-error'),
        setSelectOptions('', '', [{ name: 'NIF', id: Numbers.number1 },
        { name: 'NIE', id: Numbers.number3 },
        { name: 'CIF', id: Numbers.number2 }])
      )),
      documentNumber: new InputModel( setInputModel(['ownerLegalAsistance', 'insuredListData', 'owner', 'documentNumber'], 'form1.listdata.document-number',
      { value: '', requiredText: 'form1.default-error', maxlengthText: 'form1.default-maxlenght-error'}, true)),
      name: new InputModel( setInputModel(['ownerLegalAsistance', 'insuredListData', 'owner', 'name'], 'form1.listdata.name',
      { value: '', requiredText: 'form1.default-error'}, true)),
      firstSurname: new InputModel( setInputModel(['ownerLegalAsistance', 'insuredListData', 'owner', 'firstSurname'], 'form1.listdata.first-surname',
      { value: '', requiredText: 'form1.default-error' }, true)),
      secondSurname: new InputModel( setInputModel(['ownerLegalAsistance', 'insuredListData', 'owner', 'secondSurname'], 'form1.listdata.second-surname',
      { value: ''}, true)),
      email: new InputModel( setInputModel( ['ownerLegalAsistance', 'insuredListData', 'owner', 'email'], 'form1.step4.email',
      { emailError: 'form1.default-email-error'}))
    },
    // inmueble
    inmueble: {
      // direction
      direction: new InputModel( setInputModel(['ownerLegalAsistance', 'insuredListData', 'inmueble', 'direction'], 'form1.direction',
      { requiredText: 'form1.default-error'}, true)),
      // postalCode
      postalCode: new InputModel( setInputModel(['ownerLegalAsistance', 'insuredListData', 'inmueble', 'postalCode'], 'form1.postalcode',
      { requiredText: 'form1.default-error', cpError: 'form1.default-cp-error', maxlength: '5'}, true)),
      // municipality
      municipality: new SelectModel(
        setSelectModel(['ownerLegalAsistance', 'insuredListData', 'inmueble', 'municipality'],
        setSelectValue('legal.inmueble.municipio'),
        setSelectOptions('', '', [])
      )),
      // province
      province: new InputModel( setInputModel(['ownerLegalAsistance', 'insuredListData', 'inmueble', 'province'],
      'legal.inmueble.provincia', {}))
    },
    // tanant
    tenant: {
      // documentType
      documentType: new SelectModel(
        setSelectModel(['ownerLegalAsistance', 'insuredListData', 'tenant', 'documentType'],
        setSelectValue('form1.listdata.document-type',  'form1.default-error'),
        setSelectOptions('', '', [{ name: 'NIF', id: Numbers.number1 },
          { name: 'NIE', id: Numbers.number3 }])
      )),
      // documentNumber
      documentNumber: new InputModel( setInputModel(['ownerLegalAsistance', 'insuredListData', 'tenant', 'documentNumber'], 'form1.listdata.document-number',
      { value: '', requiredText: 'form1.default-error', maxlengthText: 'form1.default-maxlenght-error'}, true)),
      // name
      name: new InputModel( setInputModel(['ownerLegalAsistance', 'insuredListData', 'tenant', 'name'], 'form1.listdata.name',
      { value: '', requiredText: 'form1.default-error'}, true)),
      // firstSurname
      firstSurname: new InputModel( setInputModel( ['ownerLegalAsistance', 'insuredListData', 'tenant', 'firstSurname'], 'form1.listdata.first-surname',
      { value: '', requiredText: 'form1.default-error'}, true)),
      // surname 2
      secondSurname: new InputModel( setInputModel(['ownerLegalAsistance', 'insuredListData', 'tenant', 'secondSurname'], 'form1.listdata.second-surname',
      { value: ''}))
    }
  },
  // Domociliation
  domiciliation: {
    acceptIban: new CheckboxModel(
      setCheckboxModel(['ownerLegalAsistance', 'domiciliation', 'acceptIban'],
      'form1.emergencyContact.acceptIban', false, 'form1.default-error')),
      ...commonLegalDomiciliation('ownerLegalAsistance')
    },
  // guarantee Selection attribute
  guaranteeSelection: guaranteeSelectionLegal('ownerLegalAsistance')
};
